<template>
  <Form @submit.native.prevent ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="login_name">
      <Input class="username" v-model="form.login_name" placeholder="请输入用户名" @on-blur="handleNameBlur">
      </Input>
    </FormItem>
    <FormItem prop="password">
      <Input class="pwd" type="password" v-model="form.password" placeholder="请输入密码">
      </Input>
    </FormItem>
    <FormItem style="margin-bottom: 0">
      <Button @click="handleSubmit" type="primary" long style="height: 40px">登录</Button>
    </FormItem>
  </Form>
</template>
<script>
import { getCookie } from '../../libs/util'
export default {
  name: 'LoginForm',
  props: {
    login_nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ]
      }
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      form: {
        login_name: '',
        password: '',
        keepLogin: false,
        autoLogin: false
      }
    }
  },
  computed: {
    rules () {
      return {
        login_name: this.login_nameRules,
        password: this.passwordRules
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$emit('on-success-valid', this.form)
        }
      })
    },
    handleNameBlur () {
      if (this.form.login_name) {
        if (getCookie(this.form.login_name)) {
          this.form.password = getCookie(this.form.login_name)
          this.form.autoLogin = true
        } else {
          this.form.password = ''
          this.form.autoLogin = false
        }
      }
    }
  }
}
</script>
